import { ADDON_PRODUCT_TYPES } from './constants';

export const makeSubAddon = subAddon => ({
  id: subAddon.id,
  next_delivery_target: subAddon.next_delivery_target,
  due_for_next_delivery: subAddon.due_for_next_delivery,
  frequency: subAddon.frequency,
  recurrence: subAddon.recurrence,
  quantity: subAddon.quantity,
  sku: subAddon.sku,
});

export const makeAddonProduct = addonProduct => ({
  product_name: addonProduct.data.product_name,
  product_type: addonProduct.data.product_type,
  price: addonProduct.data.price,
  discounted_price: addonProduct.data.discounted_price,
  details: addonProduct.data.details,
  category_ids: addonProduct.data.category_ids,
});

export const findAddonProduct = (subAddon, addonProductList) =>
  addonProductList.find(addonProduct => addonProduct.data.sku === subAddon.sku);

export const findAndMakeAddonProduct = (subAddon, addonProductList) => {
  const addonProduct = findAddonProduct(subAddon, addonProductList);

  return makeAddonProduct(addonProduct);
};

export const makeSubAddonProduct = (subAddon, addonProductList) => ({
  ...makeSubAddon(subAddon),
  ...findAndMakeAddonProduct(subAddon, addonProductList),
});

export const formatData = (subAddons, addonProductList) =>
  subAddons.map(subAddon => makeSubAddonProduct(subAddon, addonProductList));

export const addonsQuantityFormatter = (quantity, type) => {
  let quantityType = '';

  if (type === ADDON_PRODUCT_TYPES.treats) {
    quantityType = 'bag';
  } else if (type === ADDON_PRODUCT_TYPES.supplements) {
    quantityType = 'jar';
  } else {
    quantityType = 'item';
  }

  return quantity > 1
    ? `${quantity} ${quantityType}s`
    : `${quantity} ${quantityType}`;
};
